if ($('.client-center-box').length > 0) {
    var textsToRemove = ['Moje zálohové faktury', 'Moje slevy', 'Moje hodnocení produktů', 'Moje dobropisy', 'Moje diskuze u produktů', 'Moje doklady k přijaté platbě', 'Moje hodnocení u produktů'];
    $('.client-center-box ul li a').each(function() {
        var $link = $(this);
        var text = $link.text().trim();
        if (textsToRemove.some(function(t) { return t.toLowerCase() === text.toLowerCase(); })) {
            $link.closest('li').remove();
        } else {
            text = text.replace('Moje', '').trim();
            text = text.charAt(0).toUpperCase() + text.slice(1);
            $link.text(text);
            if(text === 'Objednávky'){
                $link.text('Objednávky a nabídky');
            }
            if(text === 'Dodací listy'){
                $link.text('Dodací listy nevyfakturované');
            }
        }
    });
    //$('.client-center-box ul').append('<li><a href="/nabidky/">Nabídky</a></li>')
    $('.client-center-box ul').append('<li><a href="/oblibene-polozky/">Oblíbené položky</a></li>')
    if($('.content-inner>.row+h2').text() === 'Detaily objednávky'){
        $('.content-inner').after('<div class="h5"><strong>'+textPodObjednavku+'</strong><div>')
    }

    if($('.id--18').length){
        $('.content-inner p').each(function() {
            $(this).html(function(){
              return $(this).html().replace("Ještě jste žádnou objednávku nevytvořil....", "Aktuálně nemáte žádnou rozpracovanou objednávku...");
            })
        })
    }
}